import { render, staticRenderFns } from "./appLeaveGrantedInstructions.vue?vue&type=template&id=9f2cc3be"
import script from "./appLeaveGrantedInstructions.vue?vue&type=script&lang=ts"
export * from "./appLeaveGrantedInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports